import type { ComponentSingleStyleConfig } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

const themedButton: ComponentSingleStyleConfig = {
    baseStyle: () => ({
        transition: 'none',
    }),
    variants: {
        solid: (props) => ({
            borderWidth: '1px',
            borderColor: mode('blackAlpha.200', 'whiteAlpha.100')(props),
        }),
    },
};

export default themedButton;
